import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(auth)/layout.tsx");
